import React, { useEffect, useRef, useState } from "react";
import Modal from 'react-bootstrap/Modal';

import '../../css/modal.css';
import { useSelector } from "react-redux";

const ModalTermos = props => {
    const { processo_name, showModal, setShowModal,termos } = props;
    const user = useSelector(state=>state.AppReducer.user);

    return (
        termos != null && <Modal
            show={showModal == true}
            dialogClassName="modal_width"
            onHide={() => setShowModal(false)}
        >
            <Modal.Header closeButton closeLabel=''><Modal.Title>Termos {(user.empresa==null || user.empresa.change_text==false)?'da instituição':'do processo'} {processo_name}<br /></Modal.Title></Modal.Header>
            <Modal.Body>
                <div className="custom_scrollbar">

                    <div className="jodit-wysiwyg" dangerouslySetInnerHTML={{ __html: termos }}>

                    </div>
                </div>

            </Modal.Body>
        </Modal>

    );
}

export default ModalTermos;